<template>
  <div id="app">
    <Header />
    <vue-snotify></vue-snotify>
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
// import axios from "axios";
import Header from "./pages/layout/Header";
import Footer from "./pages/layout/Footer";
export default {
  name: "App",
  components: {
    Header,
    Footer,
  },

  async created() {
    // this.$store.dispatch("setFirstView");
    this.$store.dispatch("getAllCountry");
    this.$store.dispatch("checkLogin");
  },
};
</script>

